import CompanyBanner from './CompanyBanner'
export default CompanyBanner
